import Api from './Api';
const endPoint = "baanda";

const getBaaNdaTemplates = templates => Api.get(`${endPoint}`, templates);
const upsertBaaNdaTemplate = template => Api.post(`${endPoint}`, template);

export {
    getBaaNdaTemplates,
    upsertBaaNdaTemplate,
}